
/*
    FOR CONTROL THE ADD TO CART BUTTON OF THE PRODUCT PAGE
*/
const attachedButtons = new WeakSet();
let HasAdded = false;
document.querySelectorAll(".template-product .product-form__submit, .template-product button[name=add], .template-product button[type=submit]").forEach(button => {
if (!attachedButtons.has(button)) {
    attachedButtons.add(button);
    button.addEventListener("click", async (event) => {
       if (HasAdded) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        console.log("a");
        HasAdded = true;
        const activeOption = document.querySelector('.subscription-option.active');    
        if (activeOption) {
            // Retrieve the data-id and data-type from the active subscription-option
            const dataId = activeOption.getAttribute('data-id');
            let dataType = activeOption.getAttribute('data-type');
            if(dataType == "one-time"){
              dataType = document.querySelector('.one-time input[name="quantity"]').value;
              //alert(dataType);
            }
            console.log('Active Subscription Option:');
            console.log('Data ID:', dataId);
            console.log('Data Type:', dataType);

            const sellingPlan = dataId; // Pass the data-id to the selling_plan
            
            const itemProperties = {
              shipping_interval_unit_type: "months",
              shipping_interval_frequency: dataType
            };
            

            
            // Assuming you have a product ID, variant ID, or other necessary data
            const productId = activeOption.getAttribute('product-id'); 
            //document.querySelector('input[name="id"]').value; // Variant ID from the product page
                
            // Define the selling plan and item properties
            const formData = new FormData();
            formData.append('id', productId); // Product Variant ID
            if(sellingPlan){
              formData.append('selling_plan', sellingPlan); // Selling Plan              
            }else {
              formData.append('quantity', dataType);
            }
            //Do not add property for on time product add to cart

            if(activeOption.getAttribute('data-type') != "one-time"){
              for (const [key, value] of Object.entries(itemProperties)) {
                formData.append('properties[' + key + ']', value); // Add each key-value pair in the properties object
              }
            }

            // formData.append('properties', JSON.stringify(itemProperties)); // Item Properties
            
            // Send the data to the Shopify cart using the AJAX API
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                console.log('Product added to cart:', data);
                // Optionally, redirect to cart page or update cart UI
                window.location.href = '/cart';
            })
            .catch(error => {
                console.error('Error adding product to cart:', error);
            });

            
            
        }
        
    }, {
        capture: 10 // tells the browser to handle this click in the capture phase, which is the earliest phase of event propagation.
    });
}
});

/*
    UPDATE SUBSCRIPTION BOX
*/
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const targetType = urlParams.get("data-type");

  if (targetType) {
    const options = document.querySelectorAll("subscription-option");

    options.forEach((option) => {
      if (option.getAttribute("data-type") === targetType) {
        option.classList.add("active");
      } else {
        option.classList.remove("active"); // Optional: remove active from others
      }
    });
  }
});
